import { faLockKeyhole } from '@fortawesome/pro-regular-svg-icons';

import { RevealSecretModal } from '@components/Modals';
import { Button, Icon, Modal } from '@components/Shared';

type Props = {
  value: string;
};

export const ParamReferenceSecret: React.FC<Props> = ({ value }) => {
  return (
    <Modal content={<RevealSecretModal secretKey={value} />}>
      <Button theme className="flex items-center gap-1.5 text-primary">
        {value} <Icon icon={faLockKeyhole} className="text-[18px]" />
      </Button>
    </Modal>
  );
};
